import React, { useState , useEffect } from 'react';
import DoctorsGrid from '../components/layout/DoctorsGrid';
import DoctorHero from '../components/layout/DoctorHero';
import MegaparkLogo from "../assets/images/megapark.png"
import { toUrl } from '../lib/config';


const shuffle = <T,>(arr: T[]): T[] => {
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};


const HekimlerPage: React.FC = () => {
    const [doctors, setDoctors] = useState<Array<{ id: string | number; name: string; subtitle: string; photo: string; icon: React.ReactNode }>>([]);
    const [loadingDoctors, setLoadingDoctors] = useState(false);
    // DoctorHero states
    const [heroLogo, setHeroLogo] = useState<string>("");
    const [heroKicker, setHeroKicker] = useState<string>("Hekimler");
    const [heroTitleMain, setHeroTitleMain] = useState<string>("Profesyonel Doktor");
    const [heroTitleAccent, setHeroTitleAccent] = useState<string>("Ekibi");
    const [heroDesc, setHeroDesc] = useState<string>("Hastanemizin profesyonel kadrosuyla bütün birimlerinde birçok hastalığın tedavi süreci profesyonelce ilerletilip en hızlı ve güvenli şekilde tedavi imkanı sunmaktadır.");

    useEffect(() => {
        let cancelled = false;
        const run = async () => {
          try {
            setLoadingDoctors(true);
            const res = await fetch(toUrl('/api/doctors/all'));
            if (!res.ok) throw new Error('fetch_failed');
            const data = await res.json();
            const mapped = (Array.isArray(data) ? data : []).map((d: any, idx: number) => {
              const raw = d.portraitUrl || '';
              const normalized = /^https?:\/\//i.test(raw)
                ? raw
                : (raw.startsWith('/api/') ? raw : (raw ? `/api/media/${raw}` : ''));
              return ({
              id: d.id || idx,
              name: d.name || '',
              subtitle: d.shortTitle || '',
              photo: toUrl(normalized),
              icon: <span className="bi bi-gender-female"></span>,
              });
            });
            if (!cancelled) setDoctors(shuffle(mapped));
          } catch {
            // bırak: doctors boş kalabilir, UI kırılmaz
          } finally {
            if (!cancelled) setLoadingDoctors(false);
          }
        };
        run();
        return () => { cancelled = true; };
      }, []);

    // Fetch DoctorHero content
    useEffect(() => {
      let cancelled = false;
      const run = async () => {
        try {
          const res = await fetch(toUrl('/api/page-doctors-hero/hekimler'));
          if (!res.ok) throw new Error('fetch_failed');
          const data = await res.json();
          const obj = Array.isArray(data) ? (data[0] || {}) : (data || {});
          if (cancelled) return;
          const rawLogo: string = (obj.logoUrl || '').trim();
          let normalizedLogo = '';
          if (!rawLogo) normalizedLogo = '';
          else if (/^https?:\/\//i.test(rawLogo)) normalizedLogo = rawLogo;
          else if (rawLogo.startsWith('/api/')) normalizedLogo = toUrl(rawLogo);
          else normalizedLogo = toUrl(`/api/media/${rawLogo}`);
          setHeroLogo(normalizedLogo);
          setHeroKicker((obj.kicker || 'Hekimler').trim());
          setHeroTitleMain((obj.titleMain || 'Profesyonel Doktor').trim());
          setHeroTitleAccent((obj.titleAccent || 'Ekibi').trim());
          setHeroDesc((obj.description || heroDesc).trim());
        } catch {
          // keep defaults
        }
      };
      run();
      return () => { cancelled = true; };
    }, []);

  return (
    <>
      <DoctorHero
        logoSrc={heroLogo || MegaparkLogo}
        logoAlt="Megapark Hospital"
        kicker={heroKicker}
        titleMain={heroTitleMain}
        titleAccent={heroTitleAccent}
        description={heroDesc}
      />

      {loadingDoctors ? (
        <section className="doctors-grid" aria-busy="true" aria-live="polite">
          <div className="container">
            <div style={{ padding: '24px 0', textAlign: 'center', color: '#6b7280' }}>Hekimler yükleniyor…</div>
          </div>
        </section>
      ) : (
        <DoctorsGrid items={doctors} />
      )}
    </>
  );
};

export default HekimlerPage;
